import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { Toaster } from 'app/shared/lib/toaster';
import { bindable } from 'aurelia-typed-observable-plugin';
import { EmailTemplateRecipient } from 'app/core/models/essette-api';
import { EmailService } from 'app/core/services/email-service';
import { deepClone } from 'app/shared/lib/utilities';
import { CopyOptions } from 'app/core/components/email-notifications/email-notifications-recipients';

@autoinject()
export class EditRecipient extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ defaultBindingMode: bindingMode.twoWay })
    protected recipient: EmailTemplateRecipient | null = null;

    // Copy options for copy dropdown
    @bindable.array({ defaultBindingMode: bindingMode.toView })
    protected copyOptions = CopyOptions;

    protected maxDescriptionLength: number = 200;
    protected maxEmailLength: number = 200;

    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: EmailService,
        private readonly toaster: Toaster,
        ...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    public reset(): void {
        this.recipient = null;
    }

    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        return this.saveRecipient();
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    private async saveRecipient(): Promise<boolean> {
        if(!this.recipient?.id) return false;

        let isSuccessful: boolean = false;
        try {
            this.state.beginSave();

            const updatedRecipient = deepClone(this.recipient);

            updatedRecipient.copy = updatedRecipient.copy?.toLowerCase();

            if(updatedRecipient.user) {
                updatedRecipient.recipient = undefined;

                const userInfo = updatedRecipient.user;
                updatedRecipient.user = {
                    login: {
                        id: userInfo.login?.id
                    }
                };
            }
            else {
                updatedRecipient.user = undefined;
            }

            const response = await this.service.updateEmailTemplateRecipient(updatedRecipient);
            isSuccessful = response.isSuccessful;
            return isSuccessful;
        } catch(error) {
            throw error;
        } finally {
            this.toaster.standard.saved('core:emailTemplate.recipient.$', isSuccessful);
            this.state.endSave();
        }
    }
}
